export type ApiRequest = {
  isLoading: boolean
  isDone: boolean
  hasError: boolean
}

export const ApiRequestDefaultValues = {
  isLoading: false,
  isDone: false,
  hasError: false,
}

export type RequestsState = {
  [actionType: string]: {
    default: ApiRequest

    [key: string]: ApiRequest
  }
}
